import { Col, message, Tabs } from "antd";
import COLORS from "common/Colors";
import React, { useEffect, useState } from "react";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import styled from "styled-components";
import AllAnnouncement from "./AllAnnouncement";
import MyAnnouncement from "./MyAnnouncement";
import { CALL_FEATCH_API } from "common/API";
import { useSelector } from "react-redux";
import { getUserInfo } from "redux/selectors";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";

const AnnouncementWrap = styled.div`
	
  .ant-tabs-nav {
    border-radius: 5px;
    font-weight: 500;
    color: ${COLORS.TEXT.PRIMARY};
  }
  .ant-tabs-tab {
    font-size: 16px;
    &:hover {
      color: ${COLORS.TEXT.PRIMARY};
    }
  }
  .ant-tabs-ink-bar {
    background: ${COLORS.TAB};
    font-weight: bold;
    position: absolute;
    bottom: -1px !important;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${COLORS.TAB};
    font-weight: 500;
    font-size: 16px;
  }

  .ant-tabs-nav::before {
    border: none !important;
  }
  .ant-tabs-nav-list {
    border-bottom: 2px solid #80808033;
  }

  @media (min-width: 320px) and (max-width: 420px) {
    .ant-tabs-tab {
      margin: 0 !important;
    }
    .ant-tabs-nav .ant-tabs-nav-list {
      gap: 1rem;
    }
  }
`;

const Announcement = () => {
	const [allData, setAllData] = useState([]);
	const [myData, setMyData] = useState([]);
	const [loading, setLoading] = useState(false);
	const userInfo = useSelector(getUserInfo);
	const location = useLocation();
	const [tabId, setTabId] = useState(location?.state?.activeTab || "1");
	const history = useHistory();
	useEffect(() => {
		if (allData?.length === 0) {
			getAnnouncements("all");
		}
	}, []);

	useEffect(() => {
		if (tabId === "2" && myData?.length === 0) {
			getAnnouncements("mine");
		}
	}, [tabId]);

	const getAnnouncements = async (type) => {
		try {
			setLoading(true);
			let url = "insyts-user-dashboard/getannouncement";

			if (type === "mine") {
				const params = new URLSearchParams();
				params.append("loginUserId", userInfo?.userid);
				params.append("type", "mine");
				url += `?${params.toString()}`;
			}

			const response = await CALL_FEATCH_API(url, "get");
			if (response?.status === "SUCCESS") {
				if (type === "mine") {
					setMyData(response?.response?.data || []);
				} else {
					setAllData(response?.response?.data || []);
				}
			}
		} catch (error) {
			message.error("Announcement API error:", error);
		} finally {
			setLoading(false);
		}
	};

	const onChange = (key) => {
		setTabId(key);
	};

	const items = [
		{
			key: "1",
			label: "All",
			children: <AllAnnouncement data={allData} loading={loading} />,
		},
		{
			key: "2",
			label: "Mine",
			children: <MyAnnouncement data={myData} loading={loading} onRefresh={() => getAnnouncements("mine")} />,
		},
	];
	return (
		<AnnouncementWrap>
			<div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
				<h6>Announcement</h6>
				<ButtonOutlined className="border-0 m-0"  onClick={() => history.push("/dashboard")}>
				  <span style={{color: "#1677ff"}}>Back to Dashboard</span>
				</ButtonOutlined>
			</div>
			<Tabs activeKey={tabId} items={items} onChange={onChange} />
		</AnnouncementWrap>
	);
};

export default Announcement;
